import { render, staticRenderFns } from "./Saldoapprove.vue?vue&type=template&id=8491c3aa&scoped=true"
import script from "./Saldoapprove.vue?vue&type=script&lang=js"
export * from "./Saldoapprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8491c3aa",
  null
  
)

export default component.exports